/* tslint:disable */
/* eslint-disable */
export enum SimcardSortColumn {
  Iccid = 'ICCID',
  CraneId = 'CRANE_ID',
  RouterId = 'ROUTER_ID',
  ExpDate = 'EXP_DATE'
}
